module.exports = __webpack_public_path__ + "img/nature-18.da3bbd3a.jpg";